import { SET_COUNTRY_CODE } from '../const';

export default (countryCode) => {
  return {
    type: SET_COUNTRY_CODE,
    countryCode: countryCode
  }
};
